import React from 'react';
import GridControls from './GridControls';

interface YAxisGridProps {
  propKey: string;
  property: any;
  axisProps: any;
  enableGrids: (propKey: string, option: string, value: any) => void;
  updateAxisOptions: (axis: string, option: string, value: any, series?: string) => void;
  isMultiSeries?: boolean;
  iconColor?: string;
}

const YAxisGrid: React.FC<YAxisGridProps> = ({
  propKey,
  property,
  axisProps,
  enableGrids,
  updateAxisOptions,
  isMultiSeries = false,
  iconColor,
}) => {
  return (
    <GridControls
      axisType="y"
      propKey={propKey}
      property={property}
      axisProps={axisProps}
      enableGrids={enableGrids}
      updateAxisOptions={updateAxisOptions}
      isMultiSeries={isMultiSeries}
      iconColor={iconColor}
    />
  );
};

export default YAxisGrid;
